// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2NTcY","container":"Banner_container__3rNJq","subtitle":"Banner_subtitle__2tttm","bannerLink":"Banner_bannerLink__1988A","title":"Banner_title__3pJ3i"};